import { useLocalizedString } from '@volvo-cars/react-locale-provider';
import { label as labelTranslations } from '../../i18n/play/i18n';
import { IconButton, type LocalizedIconButtonProps } from '../icon-button';

/**
 * A button for playing media content.
 * Uses the useLocale hook from LocaleProvider context to provide an accessible label
 * based on the current locale, or wraps with one if `locale` is provided.
 */
export function PlayIconButton(props: LocalizedIconButtonProps) {
  const label = useLocalizedString(labelTranslations);
  return <IconButton icon="play" aria-label={label} {...props} />;
}
